import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Find the main scrollable container
    const mainElement = document.querySelector('main')
    if (mainElement) {
      mainElement.scrollTo(0, 0)
    }
    // Also scroll window (fallback)
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
